import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/whatsapp/WhatsAppFloat";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Cenografia from "./pages/Cenografia";
import Iluminacao from "./pages/Iluminacao";
import Portfolio from "./pages/Portfolio";
import Contato from "./pages/Contato";

function AppLayout() {
  const location = useLocation();
  const isIluminacao = location.pathname === "/iluminacao";

  return (
    <>
      <Header />

      <main className={isIluminacao ? "theme-iluminacao" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cenografia" element={<Cenografia />} />
          <Route path="/iluminacao" element={<Iluminacao />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contato" element={<Contato />} />
        </Routes>
      </main>

      <Footer />

      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppLayout />
    </Router>
  );
}

export default App;
